module.exports = __webpack_public_path__ + "assets/142102117b8fc981aac938aef39a73f3.mp3";